module.exports = __webpack_public_path__ + "static/media/auto2.9fcf3bae.jpg";